import React, { useState } from 'react';

import Sidebar               from '../../components/organisms/Sidebar/Sidebar';

import UsersManagement       from '../../components/organisms/UsersManagement/UsersManagement';

import UserLogs              from '../../components/organisms/UserLogs/UserLogs';

import SecufireActionLogs    from '../../components/organisms/SecufireActionLogs/SecufireActionLogs';

import DashboardHome         from '../../components/organisms/DashboardHome/DashboardHome';

import './DashboardTemplate.css';
 
const DashboardTemplate = ({

  activeSection,

  onSectionChange,

  isWsConnected,

  homeSelectedAdminId,

  onHomeAdminSelect,

  users,

  loadingUsers,

  adminsList,

  onCreateUser,

  onUpdateUser,

  onToggleStatus,

  onDeleteUser,

  onSupervisionAdd,

  onSupervisionRemove,
  onSupervisionReplace,
  onSupervisionReplaceAll,
  onShareHierarchy,

  currentUser,

  onOpenBulkEmail,

  isSendingBulkEmail,

  logsData, loadingLogs, startDate, endDate, onDateChange,

  selectedUserId, onUserSelect, userDetailData, loadingUserDetail,

  authAdmins, authSelectedAdminId, onAuthAdminSelect,

  secufireLogsData, loadingSecufireLogs, secufireStartDate, secufireEndDate,

  onSecufireDateChange, secufireUsers, secufireSelectedUserId, onSecufireUserSelect,

  secufireUserDetailData, loadingSecufireUserDetail, selectedMs, onMsSelect,

  admins, selectedAdminId, onAdminSelect,

  onEndpointDrill, endpointDrillData, onEndpointDrillClose,

  onUserDrill, userDrillData, onUserDrillClose,

  onRefreshAuthLogs, refreshingAuth,

  onRefreshSecufireLogs, refreshingSecufire,

  liveLogs, loadingLiveLogs, userActivityCounts, onlineStatus,

  notifSlot,

  onNotifNavigate,

  onToggleUserStatus,
  // filtre interne/externe — AUTH
  authIsInternal,
  onAuthIsInternalChange,

  // filtre interne/externe — SECUFIRE
  isInternal,
  onIsInternalChange,
}) => {

  // État du panel "Mon profil" — partagé entre Sidebar et UsersManagement
  const [showProfile, setShowProfile] = useState(false);
 
  const renderContent = () => {

    switch (activeSection) {
 
      case 'users':

        return (
<UsersManagement

            usersList={users}

            isLoading={loadingUsers}

            adminsList={adminsList}

            onUserCreate={onCreateUser}

            onUserUpdate={onUpdateUser}

            onUserToggle={onToggleStatus}

            onUserDelete={onDeleteUser}

            onSupervisionAdd={onSupervisionAdd}
            
            onSupervisionRemove={onSupervisionRemove}

            onSupervisionReplaceAll={onSupervisionReplaceAll}

            onShareHierarchy={onShareHierarchy}

            onOpenBulkEmail={onOpenBulkEmail}

            isSendingBulkEmail={isSendingBulkEmail}

            onToggleUserStatus={onToggleUserStatus}

            onOpenOwnProfile={() => setShowProfile(true)}

          />

        );
 
      case 'userLogs':

        return (
<UserLogs

            data={logsData} loading={loadingLogs}

            startDate={startDate} endDate={endDate} onDateChange={onDateChange}

            selectedUserId={selectedUserId} onUserSelect={onUserSelect}

            userDetailData={userDetailData} loadingUserDetail={loadingUserDetail}

            admins={authAdmins} selectedAdminId={authSelectedAdminId}

            onAdminSelect={onAuthAdminSelect}

            onRefresh={onRefreshAuthLogs} refreshing={refreshingAuth}

            notifSlot={notifSlot}
            isInternal={authIsInternal}               
            onIsInternalChange={onAuthIsInternalChange}

          />

        );
 
      case 'secufireActionLogs':

        return (
<SecufireActionLogs

            data={secufireLogsData} loading={loadingSecufireLogs}

            startDate={secufireStartDate} endDate={secufireEndDate}

            onDateChange={onSecufireDateChange}

            users={secufireUsers} selectedUserId={secufireSelectedUserId}

            onUserSelect={onSecufireUserSelect}

            userDetailData={secufireUserDetailData}

            loadingUserDetail={loadingSecufireUserDetail}

            selectedMs={selectedMs} onMsSelect={onMsSelect}

            onEndpointDrill={onEndpointDrill} endpointDrillData={endpointDrillData}

            onEndpointDrillClose={onEndpointDrillClose}

            onUserDrill={onUserDrill} userDrillData={userDrillData}

            onUserDrillClose={onUserDrillClose}

            admins={admins} selectedAdminId={selectedAdminId} onAdminSelect={onAdminSelect}

            onRefresh={onRefreshSecufireLogs} refreshing={refreshingSecufire}

            notifSlot={notifSlot}

             isInternal={isInternal}               // reste celui de secufire, inchangé
      onIsInternalChange={onIsInternalChange}

          />

        );
 
      case 'dashboard':

      default:

        return (
<DashboardHome

            admins={adminsList ?? []}

            users={users ?? []}

            loadingAdmins={loadingUsers}

            loadingUsers={loadingUsers}

            selectedAdminId={homeSelectedAdminId}

            onSelectAdmin={onHomeAdminSelect}

            currentUser={currentUser}

          />

        );

    }

  };
 
  return (
<div className="dashboard-template">
<Sidebar
        activeSection={activeSection}
        setActiveSection={onSectionChange}
        showProfile={showProfile}
        onOpenProfile={() => setShowProfile(true)}
        onCloseProfile={() => setShowProfile(false)}
      />
<div className="dashboard-content">
<div className="content-wrapper">

          {renderContent()}
</div>
</div>
</div>

  );

};
 
export default DashboardTemplate;